import DetailChoice from './DetailChoice';
import DetailChoiceFeat from './DetailChoiceFeat';

export default DetailChoice;
export { DetailChoice, DetailChoiceFeat };
